import cn from 'classnames'
import { promotionDate } from '@lib/promotion/utils'
import { BookPromotionProps } from './interface'

export function BookPromotion({ data, isDrawer }: BookPromotionProps) {
  return (
    <>
      {data.length > 0 &&
        data.map(item => (
          <div
            className={cn('mobile:px-[20px]', {
              'desktop-tablet:px-[20px]': isDrawer,
            })}
          >
            <div
              className={cn(
                'mobile:flex-col my-[30px] font-medium font-mitr bg-blue-2 dark:bg-dark-9 rounded-lg',
                {
                  'desktop-tablet:flex': !isDrawer,
                  'desktop-tablet:flex-col': isDrawer,
                }
              )}
            >
              <div
                className={cn(
                  'flex items-center justify-center py-[20px] px-[50px] mobile:px-[35px] rounded-lg bg-gradient-to-b from-blue-9 via-blue-10 to-blue-9 text-white',
                  {
                    'desktop-tablet:w-[218px]': !isDrawer,
                  }
                )}
              >
                <div className='desktop:flex desktop:space-x-[5px]'>
                  <div className='text-[24px] mobile:text-[20px]'>
                    Promotion
                  </div>
                </div>
              </div>
              <div
                className={cn(
                  'mobile:flex-col desktop:space-x-[30px] items-center mobile:justify-center py-[20px] px-[50px] mobile:px-[64px]',
                  {
                    'desktop:flex': !isDrawer,
                  }
                )}
              >
                <div
                  className={cn(
                    'text-[24px] mobile:text-[20px] mobile:text-center dark:text-white-2',
                    {
                      'text-center': isDrawer,
                    }
                  )}
                >
                  {item.name}
                </div>
                <div
                  className={cn(
                    'font-light text-[24px] mobile:text-[18px] mobile:text-center dark:text-dark-10',
                    {
                      'text-center': isDrawer,
                    }
                  )}
                >
                  {promotionDate(
                    item.startPublishedAt,
                    item.endPublishedAt,
                    'ตั้งแต่วันที่',
                    true
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  )
}
